import type { Platform } from '@k2/domain/campaigns'
import { useApi } from '@/api'

export const useBrandsResource = () => {
  const api = useApi()
  const brandsOf = (organizationId: string) => api.api.v1.organizations({ organizationId }).brands
  const brandOf = (organizationId: string, brandId: string) => brandsOf(organizationId)({ brandId })

  type CreateBody = Parameters<ReturnType<typeof brandsOf>['post']>[0]
  type UpdateBody = Parameters<ReturnType<typeof brandOf>['patch']>[0]

  const getBrands = (organizationId: string) => brandsOf(organizationId).get()
  const getBrand = (organizationId: string, brandId: string) => brandOf(organizationId, brandId).get()
  const delBrand = (organizationId: string, brandId: string) => brandOf(organizationId, brandId).delete()
  const setBrandVoiceSection = (organizationId: string, brandId: string, section: { heading: string; body: string }) =>
    brandOf(organizationId, brandId).voice.put(section)
  const getBrandPlatforms = (organizationId: string, brandId: string) => brandOf(organizationId, brandId).platforms.get()
  const setBrandPlatforms = (organizationId: string, brandId: string, platforms: Platform[]) =>
    brandOf(organizationId, brandId).platforms.put({ platforms })

  function setBrand(organizationId: string, body: CreateBody): ReturnType<ReturnType<typeof brandsOf>['post']>
  function setBrand(organizationId: string, brandId: string, body: UpdateBody): ReturnType<ReturnType<typeof brandOf>['patch']>
  function setBrand(...args: [string, CreateBody] | [string, string, UpdateBody]) {
    if (args.length === 2) {
      const [organizationId, body] = args as [string, CreateBody]
      return brandsOf(organizationId).post(body)
    }
    const [organizationId, brandId, body] = args as [string, string, UpdateBody]
    return brandOf(organizationId, brandId).patch(body)
  }

  return { getBrands, getBrand, setBrand, delBrand, setBrandVoiceSection, getBrandPlatforms, setBrandPlatforms }
}
